import { render, staticRenderFns } from "./ModalUpdateLink.vue?vue&type=template&id=241f8544"
import script from "./ModalUpdateLink.vue?vue&type=script&lang=js"
export * from "./ModalUpdateLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports